<script setup>
// Empty state do kanban - usado quando o pipeline não tem leads ainda.
//
// Mostra cards-fantasma de stages com 1 lead sample em cada, sobre o
// EmptyStateLayout padrão. Slot `actions` opcional para CTA.
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';

defineProps({
  title: { type: String, default: 'Nenhum lead neste pipeline' },
  subtitle: {
    type: String,
    default:
      'Quando uma conversa receber classificação de intenção, a IA cria um lead automaticamente neste pipeline. Você também pode criar manualmente a partir de qualquer conversa.',
  },
});

const STAGES = [
  {
    name: 'Novo lead',
    color: '#6366f1',
    sample: {
      contact: 'Maria Santos',
      summary: 'Pediu cotação de moto 0km - interesse alto',
      classification: 'Quente',
    },
  },
  {
    name: 'Contato feito',
    color: '#3b82f6',
    sample: {
      contact: 'Carlos Pereira',
      summary: 'Aguardando retorno após primeira ligação',
      classification: 'Morno',
    },
  },
  {
    name: 'Proposta',
    color: '#8b5cf6',
    sample: {
      contact: 'Júlia Almeida',
      summary: 'Proposta enviada - follow-up em 2 dias',
      classification: 'Quente',
    },
  },
];
</script>

<template>
  <EmptyStateLayout :title="title" :subtitle="subtitle">
    <template #empty-state-item>
      <div class="grid grid-cols-3 gap-3 p-px">
        <div
          v-for="(stage, i) in STAGES"
          :key="i"
          class="rounded-xl border border-n-weak bg-n-solid-1 p-3 flex flex-col gap-3"
        >
          <div class="flex items-center gap-2">
            <span class="size-2 rounded-full" :style="{ background: stage.color }" />
            <p class="text-label-small font-semibold uppercase tracking-wide text-n-slate-11 mb-0">
              {{ stage.name }}
            </p>
          </div>
          <div class="rounded-lg border border-n-weak bg-n-solid-2 p-2.5 flex flex-col gap-1">
            <div class="flex items-center justify-between gap-2">
              <p class="text-body-main font-semibold text-n-slate-12 mb-0 truncate">
                {{ stage.sample.contact }}
              </p>
              <span class="text-label-small px-1.5 py-0.5 rounded bg-n-brand/10 text-n-brand font-medium uppercase tracking-wide">
                {{ stage.sample.classification }}
              </span>
            </div>
            <p class="text-body-small text-n-slate-11 mb-0 line-clamp-2">
              {{ stage.sample.summary }}
            </p>
          </div>
        </div>
      </div>
    </template>
    <template #actions>
      <slot name="actions" />
    </template>
  </EmptyStateLayout>
</template>
